import { createApp } from "vue";
import router from "./router";
import store from "./store";
import App from "./App.vue";
import Aframe from "aframe";
// resetcss
import "./assets/css/reset.css";

// tailwindcss
import "./assets/css/tailwind.css";

// i18n
import i18n from "./i18n";

import './registerServiceWorker'

// fontawesome
import {
  library
} from "@fortawesome/fontawesome-svg-core";
import {
  FontAwesomeIcon
} from "@fortawesome/vue-fontawesome";
import {
  faChevronLeft
} from "@fortawesome/free-solid-svg-icons";
import {
  faChevronRight
} from "@fortawesome/free-solid-svg-icons";
import {
 faVolumeHigh,
 faVolumeXmark,
 faPlay,
 faStop
} from "@fortawesome/free-solid-svg-icons";

library.add(
  faChevronLeft,
  faChevronRight,
  faVolumeHigh,
  faVolumeXmark,
  faPlay,
  faStop
)

const app = createApp(App);
app.component("font-awesome-icon", FontAwesomeIcon);
app.use(router);
app.use(store);
app.use(i18n);
app.use(Aframe);
app.mount("#app");
